"use client";

import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const NAMESPACE = "new-fdm-fused-deposition-modeling";

const ROWS_BEFORE = [
	{ noteKey: "fdmTolerancesRow1Note", descKey: "fdmTolerancesRow1Desc" },
	{ noteKey: "fdmTolerancesRow2Note", descKey: "fdmTolerancesRow2Desc" },
] as const;

const ROWS_AFTER = [
	{ noteKey: "fdmTolerancesRow4Note", descKey: "fdmTolerancesRow4Desc" },
	{ noteKey: "fdmTolerancesRow5Note", descKey: "fdmTolerancesRow5Desc" },
	{ noteKey: "fdmTolerancesRow6Note", descKey: "fdmTolerancesRow6Desc" },
	{ noteKey: "fdmTolerancesRow7Note", descKey: "fdmTolerancesRow7Desc" },
] as const;

export default function FdmGeneralTolerances() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<h2 className="mb-6 text-2xl font-bold leading-tight text-black sm:mb-8 sm:text-[30px] md:mb-10 md:text-4xl lg:mb-12">
					{t("fdmTolerancesTitle")}
				</h2>

				<div className="overflow-x-auto rounded-sm bg-[#f6ffde]">
					<table className="w-full min-w-[640px] border-collapse text-left">
						<thead>
							<tr className="bg-themePrimary400 text-white">
								<th className="w-[30%] border border-[#d2d5c9] px-5 py-3.5 text-sm font-semibold sm:px-8 sm:py-4 md:text-base">
									{t("fdmTolerancesColNote")}
								</th>
								<th className="border border-[#d2d5c9] px-5 py-3.5 text-sm font-semibold sm:px-8 sm:py-4 md:text-base">
									{t("fdmTolerancesColDesc")}
								</th>
							</tr>
						</thead>
						<tbody>
							{ROWS_BEFORE.map((row) => (
								<tr key={row.noteKey}>
									<th
										scope="row"
										className="border border-[#d2d5c9] px-5 py-5 align-middle text-sm font-bold text-black sm:px-8 sm:py-6 md:text-base"
									>
										{t(row.noteKey)}
									</th>
									<td className="border border-[#d2d5c9] px-5 py-5 align-middle text-sm leading-relaxed text-black sm:px-8 sm:py-6 md:text-base">
										{t(row.descKey)}
									</td>
								</tr>
							))}

							<tr>
								<th
									scope="row"
									rowSpan={2}
									className="border border-[#d2d5c9] px-5 py-5 align-middle text-sm font-bold text-black sm:px-8 sm:py-6 md:text-base"
								>
									{t("fdmTolerancesRow3Note")}
								</th>
								<td className="border border-[#d2d5c9] px-5 py-5 align-middle text-sm leading-relaxed text-black sm:px-8 sm:py-6 md:text-base">
									{t("fdmTolerancesRow3DescLine1")}
								</td>
							</tr>
							<tr>
								<td className="border border-[#d2d5c9] px-5 py-5 align-middle text-sm leading-relaxed text-black sm:px-8 sm:py-6 md:text-base">
									{t("fdmTolerancesRow3DescLine2")}
								</td>
							</tr>

							{ROWS_AFTER.map((row) => (
								<tr key={row.noteKey}>
									<th
										scope="row"
										className="border border-[#d2d5c9] px-5 py-5 align-middle text-sm font-bold text-black sm:px-8 sm:py-6 md:text-base"
									>
										{t(row.noteKey)}
									</th>
									<td className="border border-[#d2d5c9] px-5 py-5 align-middle text-sm leading-relaxed text-black sm:px-8 sm:py-6 md:text-base">
										{t(row.descKey)}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>

				<div className="mt-8 flex justify-center">
					<Link
						href="/contact-us"
						className="inline-flex items-center justify-center rounded bg-themePrimary400 px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:bg-opacity-80 hover:text-white md:px-8 md:py-3.5 md:text-base"
					>
						{t("fdmTolerancesContactUs")}
					</Link>
				</div>
			</div>
		</section>
	);
}
